import { CODE_MENU } from 'constants.js';

export const NODOMISCONTENIDOS = 'nodoMiscontenidos';

export const redirectMisContenidos = () => {
  try {
    const nodesString = localStorage.getItem(NODOMISCONTENIDOS);
    const nodes = JSON.parse(nodesString || '[]');
    const nameNodeRegExp = new RegExp(CODE_MENU?.CONTENIDO, 'i');

    const misContenidosArray = nodes?.filter(
      node => node?.code?.search(nameNodeRegExp) > -1,
    );

    const pathMisContenidos = misContenidosArray?.[0]?.code;
    if (pathMisContenidos) {
      return pathMisContenidos;
    }
    console.warn('NO se encontro el PATH miscontenidos', pathMisContenidos);
    return 'miscontenidos';
  } catch (error) {
    console.warn('error en redirectMisContenidos', error);
    return 'miscontenidos';
  }
};
